module.exports = __webpack_public_path__ + "static/media/posta_ostrava_2_-_2.1ad78c1c.jpg";